import {WSReqTypeEnum} from './WSReqTypeEnum'
export const WebsocketHandler = {
    data() {
        return {
            wSReqTypeEnum : WSReqTypeEnum
        }
    },
    methods: {
    }
}
